import * as z from "zod/v4";
import { ResultSchemaOf } from "./result.ts";

export const DeleteResultSchema = ResultSchemaOf(
  z.ulid().describe("Identifier of the deleted resource"),
  z.string().describe("Error message"),
);

export type DeleteResult = z.infer<typeof DeleteResultSchema>;
